module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.6@readable-stream/transform.js
// module id = Wz73
// module chunks = 0